import React, { useMemo } from 'react';

import formatDuration from 'date-fns/formatDuration';
import intervalToDuration from 'date-fns/intervalToDuration';

import AlternatingRowDataTable from '../../../common/DataTable/AlternatingRowDataTable';
import Label from '../../../common/Labels/Label';

import { formatUserLastLoginDate } from '../../../../utils/date_utils';

const formatDurationCell = (start, end) => {
  const duration = intervalToDuration({
    start, end
  });

  const formattedDuration = formatDuration(duration);

  if (!formattedDuration || formattedDuration === 0) {
    return '--';
  }
  return formatDuration(duration);
}

const LoginTimeCell = ({ value }) => (
  <Label>{formatUserLastLoginDate(new Date(value).toISOString())}</Label>
)

// End of the duration is defined by Last Access, not Current Time
const DurationCell = ({ row, value }) => {
  const start = row?.original?.start;

  return (
    <Label>{formatDurationCell(start, value)}</Label>
  )
}

const SessionTypeCell = ({ value }) => {
  const allSessionTypes = Object.values(value) || [];
  const clients = allSessionTypes.join(', ');
  return (
    <Label>{clients}</Label>
  )
}

export const UserSessionsTable = ({
  sessions = []
}) => {
  const columns = useMemo(() => [
    {
      Header: 'Login Time',
      accessor: 'start',
      Cell: LoginTimeCell,
      width: 48,
    },
    {
      Header: 'Duration',
      accessor: 'lastAccess',
      Cell: DurationCell,
      width: 32,
    },
    {
      Header: 'Session Type',
      accessor: 'clients',
      Cell: SessionTypeCell,
      width: 48,
    },
  ], []);

  const defaultSort = {
    id: 'start',
    desc: true
  }

  const defaultColumn = React.useMemo(
    () => ({
      width: 160,
    }),
    []
  )
  return (
    <AlternatingRowDataTable
      id="user-sessions-table"
      columns={columns}
      data={sessions}
      defaultColumn={defaultColumn}
      defaultSort={defaultSort}
      pagination={null}
      height={320}
    />
  )
}

export default UserSessionsTable;
